import { Message } from '../../MessageBus/Message';


export class FindQuery extends Message
{
    constructor(Id: string, Folder: string)
    {
        super("Find", { Id, Folder });
    }
}
